module.exports = __webpack_public_path__ + "img/arrow.d182db1c.svg";